export interface LiveAttributeRoot {
  setAttribute(name: string, value: string): void;
  removeAttribute(name: string): void;
}

export interface LivePanelMeasurement {
  t: number;
  close: number;
  forming: boolean;
  tickMs: number | null;
  rung: string;
}

export interface LivePanelMirror {
  t: number;
  close: number;
  forming: 0 | 1;
  tickMs: number | null;
}

export interface LiveStripMirror {
  price: number;
  tickMs: number | null;
}

export interface LiveMirror {
  panels: Record<string, LivePanelMirror>;
  strip: LiveStripMirror | null;
}

type LiveWindow = Window & { __spxLive?: LiveMirror };

function mirror(mutator: (state: LiveMirror) => void): void {
  if (typeof window === "undefined") return;
  try {
    const liveWindow = window as LiveWindow;
    const state = liveWindow.__spxLive ?? { panels: {}, strip: null };
    liveWindow.__spxLive = state;
    mutator(state);
  } catch (error) {
    console.warn(`[live-measurement] mirror refused — ${String(error)}`);
  }
}

export function writeLiveMeasurement(
  root: LiveAttributeRoot | null,
  measurement: LivePanelMeasurement,
): void {
  if (root !== null) {
    root.setAttribute("data-live-t", String(measurement.t));
    root.setAttribute("data-live-close", String(measurement.close));
    root.setAttribute("data-live-forming", measurement.forming ? "1" : "0");
    root.setAttribute("data-live-rung", measurement.rung);
    if (measurement.tickMs === null) root.removeAttribute("data-live-tick-ms");
    else root.setAttribute("data-live-tick-ms", String(measurement.tickMs));
  }
  mirror((state) => {
    state.panels[measurement.rung] = {
      t: measurement.t,
      close: measurement.close,
      forming: measurement.forming ? 1 : 0,
      tickMs: measurement.tickMs,
    };
  });
}

export function writeStripMeasurement(
  root: LiveAttributeRoot | null,
  price: number,
  tickMs: number | null,
): void {
  if (root !== null) {
    root.setAttribute("data-strip-price", String(price));
    if (tickMs === null) root.removeAttribute("data-strip-tick-ms");
    else root.setAttribute("data-strip-tick-ms", String(tickMs));
  }
  mirror((state) => {
    state.strip = { price, tickMs };
  });
}
